import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/DialogTC";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import CloseIcon from "../../../assets/images/close.svg";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomTextField from "../../CustomComponents/CustomTextField/CustomTextField";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import CustomCircularProgress from "../../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { MileageClaimStatusEnum } from "../../../config/app-globals.enum";
const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function MileageClaimActionDialog(props: any) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = useState(props.dialogOpen);
    const [apiCall, setAPICall] = useState(false);
    const [inputValue, setInputValue] = React.useState("");
    const [isInputValid, setIsInputValid] = React.useState(false);
    const [mileageClaimStatus] = useState(props.mileageClaimStatus);

    const handleClose = (confirmDelete) => {
        // setOpen(false);
        setInputValue("");
        setIsInputValid(false);
        confirmDelete ? setAPICall(true) : setAPICall(false);
        props.dialogClose(false, confirmDelete, inputValue);
    };

    React.useEffect(() => {
        setOpen(props.dialogOpen);
        if (mileageClaimStatus === MileageClaimStatusEnum.APPROVED) {
            setIsInputValid(true);
        }
        console.log("mileageClaimStatus", mileageClaimStatus)
    }, [props.dialogOpen]);

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        validateInput(value)

    }

    const validateInput = (value) => {
        if (mileageClaimStatus === MileageClaimStatusEnum.APPROVED || (value && value.trim().length > 0)) {
            setIsInputValid(true);
        } else {
            setIsInputValid(false);
        }
    }

    return (
        <CustomDialog
            onClose={() => handleClose(false)}
            aria-labelledby="customized-dialog-title"
            open={open}
            className={classes.dialogWrapper}
        >
            <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => handleClose(false)}
            >
                <img src={CloseIcon} />
            </IconButton>
            <DialogContent className={classes.reportDialogContentWrapper}>
                <Typography className={classes.reportTitle}>
                    {props.dialogMessage}
                </Typography>
                {mileageClaimStatus === MileageClaimStatusEnum.REJECTED &&
                    <CustomTextField
                        className={classes.reportEventReason}
                        fullwidth
                        multiline
                        placeholder={t("TYPE_THE_YOUR_REASON")}
                        rows={8}
                        value={inputValue}
                        onChange={handleChange}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        error={isInputValid === true ? false : true}
                    />}
            </DialogContent>
            <DialogActions className={clsx(classes.dialogActionWrapper, classes.closeReplace)}>
                {apiCall ? <CustomCircularProgress /> : <CustomButton
                    autoFocus
                    disabled={!isInputValid}
                    onClick={() => handleClose(true)}
                    color="primary"
                    className={classes.noBackground}
                    defaultrounded="true"
                >
                    {t("YES")}
                </CustomButton>}
                <CustomButton
                    className={classes.deleteView}
                    autoFocus
                    onClick={() => handleClose(false)}
                    variant="contained"
                    color="primary"
                    defaultrounded="true"
                >
                    {t("No")}
                </CustomButton>
            </DialogActions>
        </CustomDialog>
    );
}
